<template>
  <div class="card">
    <div class="card-body">
      <h6>Ticket Type Breakdown</h6>
      <div class="row">
        <div v-if="!loadingBreakdown" class="col-md-12">
            <div class="sla-usage-graph-stacked">
              <div v-if="support" v-tooltip.top="`Support - ${Math.round(support)}% - ${Math.round(breakdown.support)}hrs`" title="" class="type support" :style="`width: ${support}%;`"></div>
              <div v-if="features" v-tooltip.top="`Features - ${Math.round(features)}% - ${Math.round(breakdown.features)}hrs`" title="" class="type features" :style="`width: ${features}%;`"></div>
              <div v-if="maintenance" v-tooltip.top="`Maintenance - ${Math.round(maintenance)}% - ${Math.round(breakdown.maintenance)}hrs`" title="" class="type maintenance" :style="`width: ${maintenance}%;`"></div>
              <div v-if="warranty" v-tooltip.top="`Warranty - ${Math.round(warranty)}% - ${Math.round(breakdown.warranty)}hrs`" title="" class="type warranty" :style="`width: ${warranty}%;`"></div>
              <div v-if="warranty" v-tooltip.top="`Service Value - ${Math.round(serviceValue)}% - ${Math.round(breakdown.service_value)}hrs`" title="" class="type service_value" :style="`width: ${serviceValue}%;`"></div>
              <div v-if="unknown" v-tooltip.top="`Unknown - ${Math.round(unknown)}% - ${Math.round(breakdown.unknown)}hrs`" title="" class="type unknown" :style="`width: ${unknown}%;`"></div>
            </div>
        </div>
        <div v-else class="col-md-12 text-center">
          <span class="spinner-border text-primary"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from 'utils'
import moment from 'moment'

export default {
  props: {
    start: {
      default: moment().startOf('month')
    },
    end: {
      default: moment().endOf('month')
    },
    slaId: {
      required: false,
      default: null
    }
  },

  data () {
    return  {
      loadingBreakdown: false,
      breakdown: null
    }
  },

  computed: {
    support () {
      if (!this.breakdown || this.breakdown.total <= 0) { return 0 }
      return (this.breakdown.support / this.breakdown.total) * 100
    },
    warranty () {
      if (!this.breakdown || this.breakdown.total <= 0) { return 0 }
      return (this.breakdown.warranty / this.breakdown.total) * 100
    },
    serviceValue () {
      if (!this.breakdown || this.breakdown.total <= 0) { return 0 }
      return (this.breakdown.service_value / this.breakdown.total) * 100
    },
    features () {
      if (!this.breakdown || this.breakdown.total <= 0) { return 0 }
      return (this.breakdown.features / this.breakdown.total) * 100
    },
    maintenance () {
      if (!this.breakdown || this.breakdown.total <= 0) { return 0 }
      return (this.breakdown.maintenance / this.breakdown.total) * 100
    },
    unknown () {
      if (!this.breakdown || this.breakdown.total <= 0) { return 0 }
      return (this.breakdown.unknown / this.breakdown.total) * 100
    }
  },

  mounted () {
    this.loadBreakdown()
  },

  watch: {
    start: {
      async handler (params, oldParams) {
        this.loadBreakdown()
      }
    }
  },

  methods: {
    loadBreakdown () {
      if (!this.start || !this.end) { return }

      this.loadingBreakdown = true
      const payload = {
        start: this.start.clone().local().startOf('month').format('YYYY-MM-DD'),
        end: this.end.clone().local().endOf('month').format('YYYY-MM-DD'),
      }

      if (this.slaId) {
        payload.sla_id = this.slaId
      }

      http.post(`slas/breakdown`, payload)
        .then((response) => {
          this.loadingBreakdown = false
          this.breakdown = response.data.data
        }).catch(() => {
          this.loadingBreakdown = false
        })
    },
  }
}
</script>
